
import React from "react";

type IconTextProps = {
  text: string;
  isValid?: boolean; // Optional validity check
  defaultIcon: React.ReactNode; // Default icon to show
  successIcon?: React.ReactNode; // Optional error icon
};

export const IconText: React.FC<IconTextProps> = ({
  text,
  isValid,
  defaultIcon,
  successIcon,
}) => {
  const Icon = isValid === undefined || isValid ? successIcon : defaultIcon;

  return (
    <div
      className={`flex space-x-2 ${
        isValid === undefined
          ? "font-tertiary"
          : isValid
          ? "font-success"
          : "font-error"
      }`}
    >
      {Icon}
      <p className="body-3-regular">{text}</p>
    </div>
  );
};
